import React from 'react'
import * as R from 'ramda'

import { useModal } from 'hooks'
import { QUESTION_STATUSES } from '../model'

// NOTE: hook that exposes delete interview template question
// modal state and handlers for other local hooks and interview
// templates creator components
export const useDeleteQuestionModal = handlers => {
  const { handleDeleteQuestion, handleUpgradeQuestion } = handlers

  const [question, setQuestion] = React.useState(null)

  const { handleClose, handleOpen, isOpen } = useModal()

  const handleDeleteQuestionClose = React.useCallback(() => {
    setQuestion(null)
    handleClose()
  }, [handleClose, setQuestion])

  const handleDeleteQuestionConfirm = React.useCallback(() => {
    R.equals(question?.item?.status, QUESTION_STATUSES.INSERTED)
      ? handleDeleteQuestion(question?.index)
      : handleUpgradeQuestion(question?.index, {
          ...question?.item,
          status: QUESTION_STATUSES.DELETED,
        })
    handleClose()
  }, [question, handleClose, handleDeleteQuestion, handleUpgradeQuestion])

  const handleDeleteQuestionOpen = React.useCallback(
    ({ item, index }) => {
      handleOpen()
      setQuestion({ item, index })
    },
    [handleOpen, setQuestion],
  )

  return {
    handleDeleteQuestionClose,
    handleDeleteQuestionConfirm,
    handleDeleteQuestionOpen,
    isDeleteQuestionOpen: isOpen,
  }
}
